import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from 'src/hooks';
import {
  TextField,
  InputAdornment,
  IconButton,
  SearchIcon,
  CloseIcon,
  Box
} from 'src/components';

export default function HandbookSearchBar({
  inputColor = '#fff',
  borderColor = '#fff',
  closeDialogOnSearch,
  onClose
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;
    navigate(`/handbook/search?q=${encodeURIComponent(searchTerm.trim())}`);
    if (closeDialogOnSearch) onClose();
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ marginLeft: isMobile ? 0 : 2 }}
    >
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        placeholder="Search articles..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputLabelProps={{ style: { fontSize: 12} }}
        sx={{
          '& input:-webkit-autofill': !isMobile ? {
            WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
            WebkitTextFillColor: 'white !important',
            transition: 'background-color 5000s ease-in-out 0s'
          } : {}
        }}
        InputProps={{
          sx: {
            backgroundColor: 'transparent',
            borderRadius: 100,
            fontSize: 12,
            color: inputColor,
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            '& fieldset': {
              borderColor: borderColor,
            },
            '& input::placeholder': {
                color: inputColor,  
                opacity: 0.9,             
            },
          },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: inputColor }} />
            </InputAdornment>
          ),
          endAdornment: searchTerm && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                disableRipple
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setSearchTerm('')}
              >
                <CloseIcon fontSize="inherit" sx={{ color: inputColor }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
